import {
  AuthenticatedTemplate,
  useMsal,
  useMsalAuthentication,
} from "@azure/msal-react";
import { b2cPolicies, protectedResources } from "../config/authConfig";
import { EventType, InteractionType } from "@azure/msal-browser";
import { ApolloProvider } from "@apollo/client";
import { clientSetup } from "../../../GraphQL/setup";
import UpdateToken from "./UpdateToken";
import { useEffect, useMemo, useRef, useState } from "react";
import { constantData } from "../../../Assets/constants";

function compareIssuingPolicy(idTokenClaims, policyToCompare) {
  let tfpMatches =
    idTokenClaims.hasOwnProperty("tfp") &&
    idTokenClaims["tfp"].toLowerCase() === policyToCompare.toLowerCase();
  let acrMatches =
    idTokenClaims.hasOwnProperty("acr") &&
    idTokenClaims["acr"].toLowerCase() === policyToCompare.toLowerCase();
  return tfpMatches || acrMatches;
}

const Login = () => {
  const firstRender = useRef(true);
  const { instance } = useMsal();
  const [accessToken, setAccessToken] = useState(null);
  const { result, error: msalError } = useMsalAuthentication(
    InteractionType.Silent,
    {
      scopes: protectedResources.apiTodoList.scopes.write,
      account: instance.getActiveAccount(),
      redirectUri: window.location.origin,

    }
  );

  console.log("instance", result && result.accessToken);
  console.log("Error", msalError);

  //  useEffect(() => {
  //   if (result?.accessToken) {
  //     setAccessToken(result.accessToken);
  //   }
  // }, [result]);

  useEffect(() => {
    if (msalError) {
      console.error("Authentication error:", msalError);
      instance.loginRedirect({
        scopes: protectedResources.apiTodoList.scopes.write,
      });
    }
  }, [msalError, instance]);

  // useEffect(() => {
  //   const acquireToken = async () => {
  //     const accounts = instance.getAllAccounts();
  //     if (accounts.length > 0) {
  //       try {
  //         const response = await instance.acquireTokenSilent({
  //           account: accounts[0],
  //           scopes: protectedResources.apiTodoList.scopes.write,
  //         });
  //         setAccessToken(response.accessToken);
  //       } catch (error) {
  //         console.error("Token renewal failed:", error);
  //         instance.loginRedirect({
  //           scopes: protectedResources.apiTodoList.scopes.write,
  //         });
  //       }
  //     }
  //   };

  //   if (firstRender.current) {
  //     acquireToken(); // Acquire token on first render
  //     firstRender.current = false; // Prevent further calls on initial render
  //   }
  // }, [instance]);

  useEffect(() => {
    const checkAndRenewToken = async () => {
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        try {
          await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: protectedResources.apiTodoList.scopes.write,
          });
        } catch (error) {
          console.error("Token renewal failed:", error);
          instance.loginRedirect({
            scopes: protectedResources.apiTodoList.scopes.write,
          });
        }
      }
    };

    const interval = setInterval(
      checkAndRenewToken,
      constantData.REFRESH_TOKEN_TIMING
    ); // Every 4 minutes
    return () => clearInterval(interval);
  }, [instance]);

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      console.log("eventlog  ", event)
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload.account
      ) {
        setAccessToken(event.payload.accessToken); // Update the token state
        if (
          compareIssuingPolicy(
            event.payload.idTokenClaims,
            b2cPolicies.names.forgotPassword
          )
        ) {
          let signUpSignInFlowRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            scopes: [
              ...protectedResources.apiTodoList.scopes.read,
              ...protectedResources.apiTodoList.scopes.write,
            ],
          };
          instance.ssoSilent(signUpSignInFlowRequest);
        }
      }

      if (event.eventType === EventType.LOGIN_FAILURE) {
        console.log("event.eventType is in failure ", event)
        if (event.error && event.error.errorMessage.includes("AADB2C90118")) {
          const resetPasswordRequest = {
            authority: b2cPolicies.authorities.forgotPassword.authority,
            scopes: [],
          };
          instance.loginRedirect(resetPasswordRequest);
        }
      }
    });

    // //set initial token.
    // const account = instance.getActiveAccount();
    // if (account) {
    //   instance
    //     .acquireTokenSilent({
    //       scopes: protectedResources.apiTodoList.scopes.write,
    //       account: account,
    //     })
    //     .then((response) => {
    //       setAccessToken(response.accessToken);
    //     })
    //     .catch((e) => {
    //       console.error(e);
    //     });
    // }

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  console.log("Access Token in Login:", accessToken);

  if (firstRender.current) {
    const initializeMsal = async () => {
      await instance.initialize();
    };
    initializeMsal();
    firstRender.current = false;
  }

   const apolloClient = useMemo(
    () => clientSetup(result && result.accessToken, instance),
    [result?.accessToken, instance]
  );


  return (
    <AuthenticatedTemplate>
      <ApolloProvider
        client={clientSetup(
        result && result.accessToken,
        //   // "eyJhI1NiIsImtbGciOiJSUzpZCI6IZVhrNHh5b2pORnVtMWtsMll0djhkbE5QNC1jNTdkTzZRR1RWQndhTmsiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJlMmQ4OThiYS1jMTQ1LTQ5ODUtYjVhNC1iZDc3ZmY0MWU3NmEiLCJpc3MiOiJodHRwczovL2F0aGF5bnN5c29yZy5iMmNsb2dpbi5jb20vZjkwMDU4ZTItNjliZC00OWJmLWI4ZGItYmQ2ZGIxN2Q1MDRhL3YyLjAvIiwiZXhwIjoxNzIxNDM0MTQyLCJuYmYiOjE3MjEzNzQxNDIsIm9pZCI6IjI1MjlmNzU5LWY1ZWEtNGYyMy04ODI4LTk1NDEyMmYxZDk4ZCIsInN1YiI6IjI1MjlmNzU5LWY1ZWEtNGYyMy04ODI4LTk1NDEyMmYxZDk4ZCIsIm5hbWUiOiJTaGl2YW5zaCBUaGFrdXIiLCJlbWFpbHMiOlsidGhha3Vyc2hpdmFuc2g3NUBnbWFpbC5jb20iXSwidGZwIjoiQjJDXzFfY3JtLXNpZ24taW4iLCJub25jZSI6IjAxOTBjOWUzLThmZDAtN2E5Mi05MmI3LWZjOTY4OTczZmY0MiIsInNjcCI6IlRvRG9MaXN0LlJlYWRXcml0ZSIsImF6cCI6ImYwODM5YzRhLWEwZjYtNDk0OS04NGE2LWRmMmZjZTM4Yjg1YSIsInZlciI6IjEuMCIsImlhdCI6MTcyMTM3NDE0Mn0.msAzPl1Wx_tjef-TfBVjkjzGB-QDhB87KSkp2jUfIKBiOjdaqpHcdWBRHp-6Q7QlCsXXfYy7xRVk_KWX5RSfNl_gHZ0PRlH7Soc2tMf_Cr04KfnhgkCSLeNe7j2MwFFszCxak4y4QKsAOi_xklXj1md_NepmOFE65wp1Xfi0chp4-k-6plRBPfrqRc2nGsrH5NRNmcjIZdHVftfpFKjLNAg32nw9B90TALuWgkXuZulCgXJtVt3e-YSGwPRftrGYFOWfCBxm2U4yP9oQtKoRPrgg7M1IGI4bi6CPybPdM41wgxVCobXdaIkF2xxe9zo6e7fUKIJNgxaAfFfkdf8d3g",
          instance
        )}
        // client={apolloClient}
      >
        <UpdateToken result={result} updatedToken={accessToken} />
      </ApolloProvider>
    </AuthenticatedTemplate>
  );
};
export default Login;
